import React from "react";
import { Modal } from "react-bootstrap";
import styles from "../../_css/DeleteUserModal.module.css";
import { CustomButton } from "../UI/CustomButtons";

const ApprovePopup = ({
  show,
  onHide,
  size = "sm",
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size={size}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "20px" }}>Review Approved</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className={styles.iconSection}>
          <div className={styles.iconCircle}>
            <i>
              <img
                width={60}
                src={`${process.env.REACT_APP_PROJECT_URL}/img/green-tick.png`}
                alt="delete"
              />
            </i>
          </div>
          <div className={styles.title}>Review Approved</div>
        </div>
        <div
          className={
            styles.buttonRow + " d-flex justify-content-center gap-3 mt-4"
          }
        >
          <CustomButton text="Go to all Reviews" onClick={onHide} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ApprovePopup;
